import { Link } from 'react-router-dom'
import { GuardRokIcon } from '../components/GuardRokLogo'

const LAST_UPDATED = 'May 12, 2026'

export default function Cookies() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#030712',
        color: '#fff',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      {/* Nav */}
      <nav
        style={{
          padding: '20px 48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #0f172a',
          position: 'sticky',
          top: 0,
          background: 'rgba(3,9,18,0.95)',
          backdropFilter: 'blur(12px)',
          zIndex: 100,
        }}
      >
        <Link
          to="/"
          style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}
        >
          <GuardRokIcon size={36} />
          <div>
            <div
              style={{
                fontWeight: 800,
                fontSize: 18,
                letterSpacing: '-0.5px',
                lineHeight: 1,
                color: '#fff',
              }}
            >
              Guard<span style={{ color: '#E63946' }}>Rok</span>
              <span
                style={{ fontSize: 8, color: '#6b7280', verticalAlign: 'super', marginLeft: 1 }}
              >
                ™
              </span>
            </div>
            <div
              style={{
                fontSize: 9,
                letterSpacing: '3px',
                color: '#6b7280',
                textTransform: 'uppercase' as const,
                marginTop: 2,
              }}
            >
              AI Firewall
            </div>
          </div>
        </Link>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/docs" style={{ color: '#9ca3af', fontSize: 14, textDecoration: 'none' }}>
            Docs
          </Link>
          <Link to="/pricing" style={{ color: '#9ca3af', fontSize: 14, textDecoration: 'none' }}>
            Pricing
          </Link>
          <Link to="/login" style={{ color: '#9ca3af', fontSize: 14, textDecoration: 'none' }}>
            Sign in
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '64px 40px 96px' }}>
        <div style={{ fontSize: 12, color: '#475569', marginBottom: 12 }}>
          Last updated: {LAST_UPDATED}
        </div>
        <h1 style={{ fontSize: 36, fontWeight: 900, letterSpacing: '-1px', marginBottom: 10 }}>
          Cookie Policy
        </h1>
        <p style={{ color: '#64748b', fontSize: 11, marginBottom: 48, lineHeight: 1.7 }}>
          This policy explains what cookies GuardRok uses and why. We keep it minimal — we are a B2B
          security product, not an ad platform.
        </p>

        {[
          {
            title: 'What is a cookie?',
            body: [
              'A cookie is a small text file stored in your browser. Cookies allow websites to remember your session, preferences, and authentication state across page loads.',
            ],
          },
          {
            title: 'Cookies we use',
            body: [
              'Session token — stores your authenticated session. Required for the dashboard to work. Expires when you sign out or after 1 hour (refreshed automatically while active). Strictly necessary.',
              'Refresh token — allows your session to be renewed without re-entering your password. Expires after 60 days of inactivity. Strictly necessary.',
              'No analytics cookies. No advertising cookies. No third-party tracking cookies.',
            ],
          },
          {
            title: 'The Chrome extension',
            body: [
              'The GuardRok Chrome extension uses chrome.storage.local (not browser cookies) to store your session token (gr_token) and settings (gr_active, gr_warn). This storage is local to your browser profile and is never transmitted to advertisers or third parties.',
            ],
          },
          {
            title: 'Third-party cookies',
            body: [
              'We do not load any analytics, advertising, or tracking scripts that would set third-party cookies.',
              'Our infrastructure providers may set strictly necessary security cookies to distinguish humans from bots. These do not identify you personally.',
            ],
          },
          {
            title: 'Your choices',
            body: [
              'Because we only use strictly necessary cookies, cookie consent banners are not legally required for our service under GDPR/ePrivacy.',
              'You may clear cookies at any time through your browser settings. Clearing session cookies will sign you out of the dashboard.',
              'Blocking all cookies will prevent the dashboard from functioning.',
            ],
          },
          {
            title: 'Contact',
            body: ['Questions about cookies or data handling: privacy@guardrok.com'],
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 12, fontWeight: 700, color: '#f1f5f9', marginBottom: 12 }}>
              {title}
            </h2>
            <ul
              style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column' as const,
                gap: 8,
              }}
            >
              {body.map((line, i) => (
                <li
                  key={i}
                  style={{
                    fontSize: 11,
                    color: '#94a3b8',
                    lineHeight: 1.75,
                    paddingLeft: 16,
                    position: 'relative' as const,
                  }}
                >
                  <span style={{ position: 'absolute' as const, left: 0, color: '#374151' }}>
                    ·
                  </span>
                  {line}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          borderTop: '1px solid #0f172a',
          padding: '20px 48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ fontSize: 12, color: '#374151' }}>© 2026 GuardRok™ · aiApas LLC</div>
        <div style={{ display: 'flex', gap: 20 }}>
          <Link to="/privacy" style={{ fontSize: 12, color: '#4b5563', textDecoration: 'none' }}>
            Privacy
          </Link>
          <Link to="/terms" style={{ fontSize: 12, color: '#4b5563', textDecoration: 'none' }}>
            Terms
          </Link>
          <Link
            to="/do-not-sell"
            style={{ fontSize: 12, color: '#4b5563', textDecoration: 'none' }}
          >
            Do Not Sell
          </Link>
          <Link to="/sitemap" style={{ fontSize: 12, color: '#4b5563', textDecoration: 'none' }}>
            Sitemap
          </Link>
        </div>
      </div>
    </div>
  )
}
